import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { PrimaryButton, SecondaryButton } from '../../components/atoms/Button';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

interface ToolAdd {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
  setFormData: any;
  formData: any;
}

function CreateTaxation({
  open,
  onClose,
  onSaved,
  setFormData,
  formData,
}: ToolAdd) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    let updatedValue: any = value;

    if (name === 'gst') {
      // ✅ Allow only digits
      updatedValue = value.replace(/[^0-9]/g, '');

      // ✅ Remove leading zeros (keep single 0 if that's the only value)
      updatedValue = updatedValue.replace(/^0+(?=\d)/, '');
    }

    setFormData((prev: any) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
      sx={{ borderRadius: 10, overflow: 'hidden' }}
      PaperProps={{
        sx: {
          borderRadius: 10,
          overflow: 'hidden',
        },
      }}
    >
      <Box
        sx={{
          border: '1px solid #7B1FA2',
          borderRadius: 10,
          overflow: 'hidden',
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '22px',
            fontWeight: 'bold',
            color: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: '#181818',
            padding: '16px',
          }}
        >
          {'Add VAT Rate'}
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ backgroundColor: '#181818', padding: '24px' }}>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Typography gutterBottom>Tax Name</Typography>
              <input
                className="border border-[#D9D9D9] rounded-[9px] w-full bg-transparent h-[55px] focus:outline-none focus:ring-0 placeholder:text-[#5a5e68] pl-3"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter Tax Name"
              />
            </Grid>
            <Grid item xs={6}>
              <Typography gutterBottom>Effective From</Typography>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={
                    formData.effectiveFrom
                      ? dayjs(formData.effectiveFrom)
                      : null
                  }
                  onChange={(newValue: any) => {
                    setFormData({
                      ...formData,
                      effectiveFrom: newValue ? newValue.toISOString() : '',
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder="Select Effective From"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          height: '55px',
                          borderRadius: '9px',
                          backgroundColor: '#181818',
                          paddingLeft: '0px',

                          '& fieldset': {
                            border: '1px solid #D9D9D9',
                          },

                          '&:hover fieldset': {
                            border: '1px solid #D9D9D9',
                          },

                          '&.Mui-focused fieldset': {
                            border: '1px solid #D9D9D9',
                          },
                        },

                        '& input': {
                          padding: '0 0 0 12px',
                          color: '#000',
                        },

                        '& input::placeholder': {
                          color: '#5a5e68',
                          opacity: 1,
                        },
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={6}>
              <Typography gutterBottom>VAT Rate (%)</Typography>
              <input
                className="border border-[#D9D9D9] rounded-[9px] w-full bg-transparent h-[55px] focus:outline-none focus:ring-0 placeholder:text-[#5a5e68] pl-3"
                name="gst"
                value={formData.gst}
                onChange={handleChange}
                required
                placeholder="e.g. 20"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#181818', padding: '16px' }}>
          <DialogActions sx={{ backgroundColor: '#181818', padding: '16px' }}>
            <SecondaryButton title="Cancel" onClick={onClose} />
            <PrimaryButton title="Save" onClick={onSaved} />
          </DialogActions>
        </DialogActions>
      </Box>
    </Dialog>
  );
}

export default CreateTaxation;
